// src/components/map/layers/StateCountBadgesLayer.js
import React from 'react';
import { Marker, Tooltip } from 'react-leaflet'; // Import useMap and Tooltip
import L from 'leaflet';
import { stateCenters } from '../../../utils/stateCenters'; // Import the predefined centers
import './StateCountBadgesLayer.css'; // Import the CSS
// eslint-disable-next-line no-unused-vars
const StateCountBadgesLayer = ({ statesGeoJSON, propertyCountsByState, onStateBadgeClick }) => {
  //  const map = useMap(); // Get map instance

  // --- Add Logging ---
  // console.log('%cStateCountBadgesLayer rendering...', 'color: blue; font-weight: bold;');
  // console.log('StateCountBadgesLayer received statesGeoJSON:', !!statesGeoJSON);
  // console.log('StateCountBadgesLayer received propertyCountsByState:', !!propertyCountsByState, Object.keys(propertyCountsByState).length);
  // --- End Logging ---
  if (!statesGeoJSON || !statesGeoJSON.features || !propertyCountsByState) {
    return null;
  }

  const badges = statesGeoJSON.features
    .map((feature) => {
      const stateAbbreviation = feature.properties?.abbreviation;
      if (!stateAbbreviation) return null;

      const count = propertyCountsByState[stateAbbreviation];
      if (count === undefined || count === 0) return null; // Don't show badge if count is 0 or undefined

      const centerData = stateCenters[stateAbbreviation];
      let centerLatLng;

      if (centerData && typeof centerData.lat === 'number' && typeof centerData.lng === 'number') {
        centerLatLng = L.latLng(centerData.lat, centerData.lng);
      } else {
        console.warn(`Center data not found or invalid for state: ${stateAbbreviation}. Falling back to GeoJSON bounds center.`);
        // Fallback to bounds center if predefined center is missing or invalid
        const geoJsonLayer = L.geoJSON(feature); // Fallback
        centerLatLng = geoJsonLayer.getBounds().getCenter();
        // If even bounds center is invalid, skip this badge
        if (!centerLatLng || !centerLatLng.lat || !centerLatLng.lng) return null;
      }

      const badgeIcon = L.divIcon({
        className: 'state-count-badge',
        html: `<div>${count}</div>`,
        iconSize: [24, 24], // Explicitly set size to match CSS
        iconAnchor: [12, 12], // Anchor at the center of the 24x24 icon
      });

      const handleBadgeClick = () => {
        // The map view change (zoom/pan) is now handled by Map.js
        if (onStateBadgeClick) {
          onStateBadgeClick(stateAbbreviation, centerLatLng); // Pass abbreviation and the calculated centerLatLng
        }
      };

      return (
        <Marker key={stateAbbreviation} position={centerLatLng} icon={badgeIcon} eventHandlers={{ click: handleBadgeClick }}>
          <Tooltip>
            Click to view ({count}) properties in {stateAbbreviation}
          </Tooltip>
        </Marker>
      );
    })
    .filter(Boolean); // Remove null entries

  return <>{badges}</>;
};

export default StateCountBadgesLayer;
